import WhatsApp from './whatsapp';

export default WhatsApp;
